import { NoData } from '#/components/ui/NoData';
import { RichText } from '#/components/ui/RichText';
import { Updated } from '#/components/ui/Updated';

export const groupClass =
  'py-gap-inset divide-divider-subtle scroll-mt-(--scroll-offset) divide-y px-16';
export const rowClass =
  'flex flex-col gap-12 p-16 lg:flex-row lg:items-center lg:justify-between lg:gap-20';
export const valueClass = 'w-full lg:w-[225px] xl:w-sm';

interface StatGroupProps {
  id: string;
  title: string;
  description?: string;
  children: React.ReactNode;
}

export function StatGroup({
  id,
  title,
  description,
  children,
}: StatGroupProps) {
  return (
    <div id={id} className={groupClass}>
      <h3 className="text-fluid-base text-fg-header border-0 leading-snug font-semibold">
        {title}
      </h3>
      {description && <RichText html={description} className="border-0" />}
      {children}
    </div>
  );
}

interface StatRowProps {
  label: React.ReactNode;
  date?: string;
  description?: string;
  value?: React.ReactNode;
}

export function StatRow({ label, date, description, value }: StatRowProps) {
  return (
    <div className={rowClass}>
      <div className="text-slate-90 flow flow-6">
        <p className="text-static-14">{label}</p>
        {date && <Updated date={date} variant="time" />}
        {description && <p className="text-static-12">{description}</p>}
      </div>
      {/* Fall back to a dash when a row has no value (nullish, or a falsy guard). */}
      <div className="text-static-14 text-slate-90 shrink-0 font-semibold">
        {value == null || value === false ? <NoData /> : value}
      </div>
    </div>
  );
}
